import CommonTopsection from "../../components/TopSection";
import { Button, Col } from "react-bootstrap";
import QuickBarChartLoanNumbers from "./QuickBarChartLoanNumbers";
import QuickBarChartLoanValue from "./QuickBarChartLoanValue";
import { gridColumns_loanSubmissions } from "../../Utils/TableColumnDefs";
import CommonGrid from "../../components/CommonGrid";
import LoanBoarded from "./LoanBoarded";
import ErrorBoundary from "../../components/ErrorBoundary";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { SpinnerBlock } from "../../Utils/CustomComponent";
import { useDispatch, useSelector } from "react-redux";
import { fetchLoanSubmissions } from "../../store/reducers/submitALoanSlice/api";
import { useAbortController } from "../../hooks/useAbortController";

const SubmitALoan = () => {
  const { signal } = useAbortController();
  const dispatch = useDispatch();
  const loanSubmissionsStatus = useSelector(
    (state) => state.submitALoan.loanSubmissions.status
  );
  const loanSubmissions = useSelector(
    (state) => state.submitALoan.loanSubmissions.data
  );
  useEffect(() => {
    if (loanSubmissionsStatus === "idle") {
      dispatch(fetchLoanSubmissions({ signal }));
    }
  }, [dispatch, loanSubmissionsStatus]);

  const navigate = useNavigate();
  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <article className="container-fluid">
          <div className="p-3 pb-0  mt-1">
            <h4>Submit a Loan</h4>
          </div>
          <CommonTopsection />
        </article>
        <article className="container-fluid">
          <div className="d-flex justify-content-between p-3 align-items-center">
            <span>
              <b>All Loans</b>
            </span>
            <Button
              onClick={() => navigate("/submit-a-loan/form")}
              className="text-white"
            >
              Submit a Loan
            </Button>
          </div>
          <section className="row p-3 pt-0 d-flex flex-row align-items-stretch justify-content-stretch">
            <Col sm={10}>
              <ErrorBoundary>
                {loanSubmissionsStatus === "fulfilled" ? (
                  <CommonGrid
                    className={"pending-loan-submissions"}
                    title={"Pending Loan Submissions"}
                    gridColumns={gridColumns_loanSubmissions}
                    columnData={loanSubmissions}
                    tableTotal={["loan_amount"]}
                  />
                ) : (
                  <SpinnerBlock height="50vh" />
                )}
              </ErrorBoundary>
            </Col>
            <Col sm={2}>
              <ErrorBoundary>
                <LoanBoarded />
              </ErrorBoundary>
            </Col>
          </section>
          <section className="row p-3 pt-4">
            <Col>
              <div className="d-flex loan-value flex-column bg-white p-5">
                <ErrorBoundary className="d-flex loan-value flex-column bg-white p-5">
                  <QuickBarChartLoanValue />
                </ErrorBoundary>
              </div>
            </Col>
            <Col>
              <div className="d-flex loan-numbers flex-column bg-white p-5">
                <ErrorBoundary className="d-flex loan-numbers flex-column bg-white p-5">
                  <QuickBarChartLoanNumbers />
                </ErrorBoundary>
              </div>
            </Col>
          </section>
        </article>
      </section>
    </div>
  );
};
export default SubmitALoan;
